<template>
  <iframe :src="webUrl+'/admin/crm/tag.set'"></iframe>
</template>

<script>
export default {
  name: "label",
  setup(){
    return {
      "webUrl" : process.env.VUE_APP_DAILIAO_WEB_URL
    }
  }
}
</script>

<style scoped>

</style>